/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ShopSearchRequest} from '@cash-web/protos/squareup/cash/customersearch/api/ShopSearch.pb'
import {ShopSearchResponse} from '@cash-web/protos/squareup/cash/customersearch/api/ShopSearch.pb'


export const shopSearch = (request: ShopSearchRequest, options?: CashRequestOptions) => post<ShopSearchRequest, ShopSearchResponse>("/2.0/cash/shop-search", request, {...options, rejectOnError: true })